import React from "react";
import { Box, Typography } from "@mui/material";

const InfoTab = ({ file }) => {
  return (
    <Box
      sx={{
        p: 2,
        height: "100%",
        overflow: "auto",
        backgroundColor: "#f8f9fa",
      }}
    >
      <Typography
        variant="caption"
        sx={{
          color: "#6b7280",
          fontSize: "11px",
          fontWeight: 600,
          mb: 1,
          display: "block",
        }}
      >
        COMPLETE FILE DOCUMENT (MongoDB Structure)
      </Typography>
      <Box
        component="pre"
        sx={{
          fontFamily: "monospace",
          fontSize: "11px",
          color: "#334155",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          margin: 0,
          backgroundColor: "#ffffff",
          p: 2,
          borderRadius: 1,
          border: "1px solid #e2e8f0",
        }}
      >
        {JSON.stringify(
          {
            _id: file?.id,
            ...file,
          },
          null,
          2
        )}
      </Box>
    </Box>
  );
};

export default InfoTab;

